<template>
  <layout>
    <terms-conditions
      :wb="welcomeBack"
      :campaign-id="baseData.campaignId"
      :wftkn="wftkn"
      :terms-data="customTerms"
    />
  </layout>
</template>

<script>
  import Layout from './layout'
  import TermsConditions from '../components/terms/terms-conditions.vue'

  export default {
    components: {
      Layout,
      TermsConditions,
    },
    data() {
      return {}
    },
    computed: {
      baseData() {
        return this.$store.state.baseData
      },
      wftkn() {
        return this.$store.state.wftkn
      },
      welcomeBack() {
        return this.$store.state.welcomeBack
      },
      customTerms() {
        if (
          this.baseData.advancedOptions &&
          this.baseData.advancedOptions.customTermsOfService !== undefined
        ) {
          const data = {}
          data.customTerms = this.baseData.advancedOptions.customTermsOfService
          return data
        }
        return ''
      },
    },
  }
</script>

<style scoped></style>
